import { enhanceAnchorIntoButton } from "../helpers/dom";
import { fetchConfig } from "../helpers/fetch";

export default class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.error = false;
    this.shouldPushToKlaviyo = true;

    this.bindButtonClick();
  }

  get addButton() {
    return this.querySelector('[name="add"]');
  }

  get loadingOverlay() {
    return this.querySelector(".c-loading-overlay");
  }

  get errorContainer() {
    return this.querySelector('[data-id="add-to-cart-errors"]');
  }

  get errorTextEl() {
    return this.querySelector('[data-id="add-to-cart-error-text"]');
  }

  get cartDrawerComponent() {
    return document.getElementById("cart-snippet");
  }

  get cartDrawerId() {
    return this.addButton.dataset.controls;
  }

  bindButtonClick() {
    this.addButton.setAttribute("aria-controls", this.cartDrawerId);
    enhanceAnchorIntoButton(this.addButton, this.handleButtonClick);
  }

  handleButtonClick = () => {
    if (this.addButton.getAttribute("aria-disabled") === "true") return;

    this.enableLoading();

    const { variantId, sellingPlanId, sellingPlanGroupId, discountCode } =
      this.dataset;
    const body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1,
          ...(sellingPlanId && { selling_plan: sellingPlanId }),
          ...(sellingPlanGroupId && {
            [`selling_plan_${sellingPlanGroupId}`]: "subsave",
          }),
        },
      ],
      sections: this.cartDrawerComponent.sectionsToRender.map(
        (section) => section.section,
      ),
    });

    fetch(`${routes.cart_add_url}.js`, { ...fetchConfig(), ...{ body } }) // eslint-disable-line no-undef
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          this.error = true;
          return;
        }

        this.error = false;
        this.cartDrawerComponent.updateSectionHTML(response);
        this.cartDrawerComponent.toggleEmptyClass(response.items.length);

        postMessage({
          drawerId: this.cartDrawerId,
          drawerAction: "open",
          toggleId: this.addButton.id,
        });

        // Automatically apply discount code if attached to product
        if (discountCode) {
          const existingDiscount = document.cookie
            .split("; ")
            .find((row) => row.startsWith("discount_code="));
          if (!existingDiscount)
            document.cookie = `discount_code=${encodeURIComponent(
              discountCode,
            )}; path=/`;
        }
      })
      .then(() => this.pushEventToKlaviyo())
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.disableLoading();
      });
  };

  enableLoading() {
    this.addButton.setAttribute("aria-disabled", true);
    this.addButton.classList.add("loading");
    this.loadingOverlay.classList.remove("hidden");
  }

  disableLoading() {
    if (!this.error) this.addButton.setAttribute("aria-disabled", false);
    this.addButton.classList.remove("loading");
    this.loadingOverlay.classList.add("hidden");
  }

  handleErrorMessage(error) {
    this.errorContainer.removeAttribute("hidden");
    this.errorTextEl.textContent = error;
  }

  pushEventToKlaviyo() {
    if (!this.shouldPushToKlaviyo || !window._learnq) return;

    fetch(`${routes.cart_url}.js`) // eslint-disable-line no-undef
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        const cart = {
          total_price: response.total_price / 100,
          $value: response.total_price / 100,
          total_discount: response.total_discount,
          original_total_price: response.original_total_price / 100,
          items: response.items,
        };
        window._learnq.push(["track", "Added to Cart", cart]);
        this.shouldPushToKlaviyo = false;
      });
  }
}
